module.exports = __webpack_public_path__ + "img/2012.3bf04bda.jpg";